module.exports = __webpack_public_path__ + "img/00 banner.fcb6a847.png";